<template>
    <div class="my-3xl">
        <h2 class="h3 text-ownit-red mb-xl">
            {{ lang('E-postkonto','E-mail account') }}
        </h2>

        <div
            v-if="emailAccountsAndAliases.length === 0"
            class="text-sm text-neutral-dark -mt-lg mb-lg"
        >
            {{ lang('Du har inget e-postkonto än',"You don't have any e-mail accounts yet") }}.
        </div>

        <div v-if="emailAccountsAndAliases.length < maxPerCustomer" class="bg-white px-lg mb-lg shadow-md rounded-lg md:px-xl">
            <div class="flex items-center justify-between py-md">
                <div class="accordion-title-width pr-md font-bold md:pr-0">{{ lang('E-postkonto','E-mail account') }}</div>
                <div class="font-regular text-sm text-neutral-dark flex-grow hidden md:inline-flex">{{ lang('Utan extra kostnad','No extra cost') }}</div>
                <div class="w-full md:w-auto">
                    <create-email-account-or-alias-button :domain-options="domainOptions" />
                </div>
            </div>
        </div>

        <div v-if="emailAccountsAndAliases.length <= 2">
            <service-accordion
                v-for="emailAccountOrAlias in emailAccountsAndAliases"
                :key="emailAccountOrAlias.id"
                :title="emailAccountOrAlias.address"
                :extra-text="emailAccountOrAlias.is_alias ? lang('Vidarebefodring','Forwarding') : ''"
            >
                <email-account-or-alias
                    :initial-email-account-or-alias="emailAccountOrAlias"
                    :domain-options="domainOptions"
                    @emailAccountOrAliasUpdated="updateEmailAccountOrAlias"
                />
            </service-accordion>
        </div>
        <div v-else>
            <service-accordion :title="lang('E-postkonton','E-mail account')">
                <div class="pb-xl">
                    <ul class="list-reset">
                        <li
                            v-for="emailAccountOrAlias in emailAccountsAndAliases"
                            :key="emailAccountOrAlias.id"
                            class="border-b border-neutral-lighter"
                        >
                            <accordion :is-child="true">
                                <template slot="toggle-title">
                                    {{ emailAccountOrAlias.address }}
                                </template>

                                <template slot="extra-text">
                                    {{ emailAccountOrAlias.is_alias ? lang('Vidarebefodring','Forwarding') : '' }}
                                </template>

                                <template slot="toggle-content">
                                    <email-account-or-alias
                                        :initial-email-account-or-alias="emailAccountOrAlias"
                                        :domain-options="domainOptions"
                                        @emailAccountOrAliasUpdated="updateEmailAccountOrAlias"
                                    />
                                </template>
                            </accordion>
                        </li>
                    </ul>
                </div>
            </service-accordion>
        </div>
    </div>
</template>

<script>
    import EmailAccountOrAlias from './EmailAccountOrAlias';
    import CreateEmailAccountOrAliasButton from './CreateEmailAccountOrAliasButton';

    export default {
        components: {
            EmailAccountOrAlias,
            CreateEmailAccountOrAliasButton,
        },

        props: {
            initialEmailAccountsAndAliases: {
                type: Array,
                required: true,
            },
            domainOptions: {
                type: Array,
                required: true,
            },
            maxPerCustomer: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                emailAccountsAndAliases: this.initialEmailAccountsAndAliases,
            };
        },


        methods: {
            updateEmailAccountOrAlias(newEmailAccountOrAlias) {
                var index = this.emailAccountsAndAliases.findIndex(emailAccountOrAlias => {
                    return emailAccountOrAlias.id === newEmailAccountOrAlias.id;
                });
                this.$set(this.emailAccountsAndAliases, index, newEmailAccountOrAlias);
            },
        },
    };
</script>